import { contextFactory } from '@frontend/design-system';

export interface FormTemplateListViewContextValue {
  selectedTemplateId?: string;
  locationIdForSelectedTemplate?: string;
  isATemplateSelected: boolean;
}

export const [FormTemplateListViewContext, useFormTemplateListViewContext] =
  contextFactory<FormTemplateListViewContextValue>();
